<template>
  <button
    type="button"
    class="h-11 w-[182px] bg-cover bg-google-signin-normal active:bg-google-signin-pressed focus:bg-google-signin-focus disabled:bg-google-signin-disabled"
  />
</template>
